import { setCartPaymentTap2PayAccountDetails, setCartPaymentTap2PayAccountDetailsError, setCartPaymentTap2PayConnectionToken, setCartPaymentTap2PayConnectionTokenError, setCartPaymentTap2PayCreateSessionError, setCartPaymentTap2PayPaymentSession, setCartPaymentTap2PayPaymentSessionInvalid, setCartPaymentTap2PaySessionCreateIsLoading } from '../../../action/cartPayment'
import { setAppErrors } from '../../../action/system'
import { isDevEnvironment, retrieveErrorFromApi } from '../../../../helper'
import createTap2PayPaymentSession from '../../../axios/payment/tap2Pay/paymentSession/post'
import getTap2PayPaymentSession from '../../../axios/payment/tap2Pay/paymentSession/get'
import deleteTap2PayPaymentSession from '../../../axios/payment/tap2Pay/paymentSession/delete'
import getTap2PayConnectionToken from '../../../axios/payment/tap2Pay/paymentSession/connectionToken/post'
import accountDetails from '../../../axios/payment/tap2Pay/paymentSession/accountDetails'
import { logger } from '../../../../logger/logger'
import { publishTap2PayConnectionTokenCreatedMessage } from '../../../../helper/tap2PayMessages'

export const getTap2PayConnectionTokenThunk = (hasModalLogin) => async (dispatch, getState) => {
	try {
		logger.info(`Get tap2pay connection token: companyIndex=${getState().login.companyIndex}`)
		const res = await getTap2PayConnectionToken(hasModalLogin)
		logger.info(`Got tap2pay connection token: companyIndex=${getState().login.companyIndex}, connectionToken=${res.data?.connectionToken}`)
		dispatch(setCartPaymentTap2PayConnectionToken(res.data.connectionToken))
	} catch (error) {
		dispatch(setCartPaymentTap2PayConnectionTokenError(true))
	}
}
export const getAccountDetailsThunk = (hasModalLogin) => async (dispatch, getState) => {
	try {
		logger.info(`Get tap2pay account details: companyIndex=${getState().login.companyIndex}`)
		const res = await accountDetails(hasModalLogin)
		logger.info(`Got tap2pay account details: companyIndex=${getState().login.companyIndex}, accountDetails=${JSON.stringify(res.data)}`)
		dispatch(setCartPaymentTap2PayAccountDetails(res.data))
	} catch (error) {
		dispatch(setCartPaymentTap2PayAccountDetailsError(true))
	}
}

export const createTap2PayPaymentSessionThunk = (totalSum, paymentSource, hasModalLogin) => async (dispatch, getState) => {
	dispatch(setCartPaymentTap2PaySessionCreateIsLoading(true))
	try {
		logger.info(`Create Tap2Pay payment session: total=${totalSum} companyIndex=${getState().login.companyIndex}`)
		const res = await createTap2PayPaymentSession(totalSum, paymentSource, hasModalLogin)
		logger.info(`Created Tap2Pay payment session: total=${totalSum} sessionId=${res.data.sessionId} and clientSecret=${res.data.clientSecret} companyIndex=${getState().login.companyIndex}`)
		dispatch(setCartPaymentTap2PayPaymentSession(res.data))
	} catch (error) {
		dispatch(setCartPaymentTap2PayCreateSessionError(true))
	} finally {
		dispatch(setCartPaymentTap2PaySessionCreateIsLoading(false))
	}
}

export const getTap2PayPaymentSessionThunk = (sessionId, hasModalLogin) => async (dispatch, getState) => {
	try {
		logger.info(`Get tap2pay payment session: session=${sessionId} companyIndex=${getState().login.companyIndex}`)
		const res = await getTap2PayPaymentSession(sessionId, hasModalLogin)
		const tap2PayPaymentSession = getState().cartPayment.tap2PayPaymentSession
		if (tap2PayPaymentSession && tap2PayPaymentSession.sessionId === res.data.sessionId && res.data.status !== 'PROCESSING') {
			logger.info(`Got tap2pay payment session: session=${sessionId} status=${res.data.status} companyIndex=${getState().login.companyIndex}`)
			dispatch(setCartPaymentTap2PayPaymentSession(res.data))
		}
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

export const deleteTap2PayPaymentSessionThunk = (sessionId, hasModalLogin) => async (dispatch) => {
	try {
		const res = await deleteTap2PayPaymentSession(sessionId, hasModalLogin)
		return res.data
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

export const resetTap2PayPaymentErrorsThunk = () => dispatch => {
	dispatch(setCartPaymentTap2PayPaymentSessionInvalid(false))
}

export const provideFreshTap2PayConnectionTokenThunk = () => async (dispatch, getState) => {
	const hasModalLogin = !!getState().modalLogin.accessToken
	try {
		logger.info(`Native requested fresh tap2pay connection token: companyIndex=${getState().login.companyIndex}`)
		const tokenRes = await getTap2PayConnectionToken(hasModalLogin)
		const accountRes = await accountDetails(hasModalLogin)
		const connectionToken = tokenRes.data.connectionToken
		dispatch(setCartPaymentTap2PayConnectionToken(connectionToken))
		dispatch(setCartPaymentTap2PayAccountDetails(accountRes.data))
		if (publishTap2PayConnectionTokenCreatedMessage(connectionToken, isDevEnvironment(), accountRes.data)) {
			logger.info('Published fresh tap2pay connection token to native app')
		}
	} catch (error) {
		logger.error(`Failed to provide fresh tap2pay connection token: ${error?.message}`)
		dispatch(setCartPaymentTap2PayConnectionTokenError(true))
	}
}
